<div class="tab">
	<div *ngIf="tab?.images.length > 0" class="tab__images">
		<img *ngIf="tab?.images.length == 1; else slider" class="tab__image" src="{{ (environment.webUrl !== '' && environment.expoBuild === false ? environment.webUrl : (environment.webUrl === '' && environment.expoBuild === false ? cordova?.file.dataDirectory : '')) + tab?.images[0] }}"/>
		<ng-template #slider>
			<app-slider [slides]="tab.images" [class]="'content-slider'"></app-slider>
		</ng-template>
	</div>
	<div class="tab__path">
		<h3 class="tab__title--small" *ngIf="path.length > 0">{{ path | join:' / '}}</h3>
	</div>
	<p class="tab__text">{{ tab?.text[language] }}</p>
	<div *ngIf="tab?.link && tab?.url" class="row">
		<div class="button" (click)="onOpenLink(tab?.url[language])">{{ tab?.link[language] }} <i class="button__icon fa fa-external-link-alt"></i></div>
	</div>
</div>




// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/tab/tab.component.html